// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__CIecB","link":"Menu_link__AhZrN","searchItem":"Menu_searchItem__O48J1"};